import React, { useState } from "react";
import { PhotoModal } from "@/components/ui/photo-modal";
import { CreateFullSizeImageModalProps } from "./types";

export default function CreateFullSizeImageModal({
  isOpen,
  imageUrl,
  backImageUrl,
  onClose,
  initialView = "front",
  onViewChange,
}: CreateFullSizeImageModalProps) {
  const [activeIndex, setActiveIndex] = useState(0);

  const images = [
    ...(imageUrl
      ? [
          {
            id: "front",
            src: imageUrl,
            alt: "Dress design - front view",
          },
        ]
      : []),
    ...(backImageUrl
      ? [
          {
            id: "back",
            src: backImageUrl,
            alt: "Dress design - back view",
          },
        ]
      : []),
  ];
  const requestedIndex = images.findIndex(image => image.id === initialView);
  const initialIndex = requestedIndex >= 0 ? requestedIndex : 0;
  const handleActiveIndexChange = (nextIndex: number) => {
    setActiveIndex(nextIndex);
    const nextView = images[nextIndex]?.id;
    if (nextView === "front" || nextView === "back") {
      onViewChange?.(nextView);
    }
  };

  React.useEffect(() => {
    if (isOpen) {
      setActiveIndex(initialIndex);
    }
  }, [initialIndex, isOpen]);

  if (images.length === 0) return null;

  return (
    <PhotoModal
      open={isOpen}
      onOpenChange={open => !open && onClose()}
      images={images}
      activeIndex={activeIndex}
      onActiveIndexChange={handleActiveIndexChange}
      title="Image view"
    />
  );
}
